import { PaymentMethod } from './payment-method';
import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('customers', { routeName: 'customerResourceRoute' })
export class Customer extends Resource {
    public firstName: string;
    public lastName: string;
    public email: string;
    public paymentMethod: PaymentMethod;
    public selected = false;
    public id: string;
    public adminUsers: any;
    public profileName: string;
    public name: string;
    public profileData: any;
    public label: string;
    public identityProviders: any;
    public parentCustomerId: string;
    enabledProfiles: any;

}
